import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import WSprites from '../../assets/images/sprites/wsprite.png'

export const DashboardLinksDiv = styled(Box)(() => ({
  margin: 0,
  fontFamily: `'SharpSansDisplayNo1-Medium', tahoma, helvetica, arial, sans-serif`,
  fontSize: 16,
  fontWeight: 600,
  lineHeight: 1.5,
  cursor: 'pointer',
  '& li': {
    display: 'block',
    textDecoration: 'none',
    color: '#131313',
    position: 'relative',
    borderRadius: 9,
    backgroundColor: '#ffffff',
    boxShadow: '0 4px 8px 2px rgba(0,0,0,0.2)',
    margin: '0 0 20px',
    '&::after': {
      content: '""',
      display: 'inline-block',
      backgroundImage: `url(${WSprites})`,
      backgroundPosition: '-1448px -217px',
      width: 16,
      height: 11,
      transform: 'rotate(270deg)',
      position: 'absolute',
      right: 25,
      top: '50%',
      marginTop: -5.5,
      transition: 'none',
    },
    '& a': {
      textDecoration: 'none',
      color: 'inherit',
      display: 'block',
      padding: '15.5px 20px',
      '&:hover': {
        textDecoration: 'none',
      },
    },
  },
}))